import React from 'react';
import { TableIcon } from './styles';
import chevron_down from '../../../images/chevron_down.png';

const TableChevron = (props) => <TableIcon src={chevron_down} {...props} />;
export default TableChevron;
